'use client'
import { with_comma } from "@/util/comma";
import getThumbnail from "@/util/getThumbnail";
import React, { useContext, useEffect, useRef, useState } from "react";
import defaultThumnail from "@/public/image/etc/default_thumnail.png"
import EditView from "./edit";
import { editPageTypes } from "@/type/edit";
import { AuthContext } from "@/context/authContext";
import { useTranslations } from "next-intl";
import LocaleFormat from "../etc/localeFormat";


export interface ImageListProps extends React.HTMLAttributes<HTMLUListElement> {
    list: any[]
    setContent: Function

    fetchData?: () => void
    post?: string
    writeAuth?: boolean
    editAuth?: boolean
    editPage?: editPageTypes
}

const ImageList = React.forwardRef<HTMLUListElement, ImageListProps>(
    ({  list, 
        setContent,

        fetchData,
        post,
        writeAuth,
        editAuth,
        editPage,
         ...rest }, ref) => {
        const [editContent, setEditContent] = useState<any>()
        const [editView, setEditView] = useState<boolean>(false)
        const { user } = useContext(AuthContext)

        const mounted = useRef(false);

        const t = useTranslations("Text")
        const a = useTranslations("Sentence")

        // useEffect(() => {
        //     if (!mounted.current) {
        //         mounted.current = true;
        //         return; 
        //     }
        //     window.location.reload();
        // }, [user, ]);

        return (
            <>
                {
                    editView
                    && <EditView post={post ?? ""}
                        editContent={editContent}
                        setSelectContent={setContent}
                        setEditView={setEditView}
                        fetchData={fetchData ?? (() => {})}
                        editPage={editPage as editPageTypes} />
                }
                <ul className="image-list">
                    {
                        list && list.length ?
                            list.map((li, index) => (
                                <li key={index} onClick={e => {
                                                    setContent(li.id)
                                                    setEditView(false)
                                                }}>
                                    {/* <img src={iconUrl + news.thumbnail} alt="" /> */}
                                    <div className="list-tumbnail">
                                        <img src={getThumbnail(li)} alt="thumnail"
                                            onError={(e) => {
                                                e.currentTarget.onerror = null; // 무한 루프 방지
                                                e.currentTarget.src = defaultThumnail.src;
                                            }} />
                                    </div>
                                    <div className="list-content">
                                        <p>{li.title}</p>
                                        <p className="info">
                                            <span>{t("댓글")} {li.comment_count || li.comments?.length || 0}</span>
                                            <span>{t("추천")} {li.like_count || 0}</span>
                                            <span>{<LocaleFormat date={li.create_dt} format="MM-DD" />}</span>

                                            <span className="auther">{li.author_name}</span>
                                        </p>
                                    </div>
                                </li>
                            ))
                            : <li className="empty">{a("InvalidData")}</li>
                    }
                </ul>
                
                {
                    writeAuth && user.is_authenticated
                    && <div className="btns">
                        <div></div>
                        <div>
                            <button onClick={e => {
                                setEditContent(undefined)
                                
                                setContent(-1)
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                setEditView(true)
                            }}
                            className={`writeBtn`}>{t("글쓰기")}</button>
                        </div>
                    </div>
                } 
            </>
        );
    }
);

export default ImageList;